import AOS from 'aos';
import AccordionComponent from './modules/accordionModule';
import AnchorScroll from './modules/anchorScrollModule';
import ProductItem from './modules/productPageModule';
import TrustedByCarousel from './modules/trustedByCarouselModule';
import SystemRequirements from './modules/systemRequirements';
import Menu from './modules/menuModule';
import Gallery from './modules/galleryModule';
import LongHeroCarousel from './modules/longHeroCarouselModule';
import InviteMember from './modules/inviteMemberModule';
import PriceSwitch from './modules/priceSwitchModule';
import ProductHero from './modules/productHeroModule';
import ProductPayment from './modules/productPaymentModule';
import PasswordChecker from './modules/passwordCheckerModule';
import AccountPage from './modules/accountPageModule';
import MobileMenu from './modules/mobileMenuModule';
import VersionBannerCarousel from './modules/versionBannerCarouselModule';
import PricingCarousel from './modules/pricingCarouselModule';
import Toast from './modules/toastModule';
//pages
import NewsHub from './modules/newsHubModule';
import NewsNavigation from './modules/newsNavigationModule';
Menu();
Toast();
MobileMenu();
Gallery();
NewsHub();
NewsNavigation();
AccordionComponent();
AnchorScroll();
ProductItem();
TrustedByCarousel();
SystemRequirements();
LongHeroCarousel();
InviteMember();
PriceSwitch();
ProductHero();
ProductPayment();
PasswordChecker();
AccountPage();
VersionBannerCarousel();
PricingCarousel();
AOS.init({
    once: true,
    mirror: false,
});
